<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #SHOWWAREHOUSE>
      <div class="cnb-div">
        <span class="cnb-num" v-for="item in list" :key="item">{{ item }}</span>
      </div>
    </template>
    <template #cost="{ visible, params, close }">
      <CostPage :rows="params" :close="close" v-if="visible" />
    </template>
    <template #showDetails="{params}">
      <div style="height: 650px; overflow: auto">
        <Tag
          type="border"
          v-for="item in params.list"
          :key="item"
          size="large"
          style="height: 32px; line-height: 32px"
        >
          {{ item }}
        </Tag>
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  operEndTripBill,
  addEndTripBill,
  moveEndTripBill,
  exportEndTripBill,
  getEndTripBill,
  addRemark,
  exportPreAlert,
  createBill,
  order
} from "@/api/endTripManage/endTripBill";
import {getAllClient, searchClient} from "@/api/user/client";
import { getAirport } from "@/api/system/airportList";
import { getExtractConfig } from "@/api/extract/new";
import { getSelectType, getKeysType } from "@/api/public";
import cTable from "@/base/common/index";
import copyClick from "@/utils/copyClick";
import CostPage from "@/view/trackers/cost_page";
export default {
  name: "endTripBill",
  components: {
    cTable,
    CostPage
  },
  async mounted() {
    let list = (await getExtractConfig()).data.payload.list;
    let airportList = (await getAirport()).data.payload.rows;
    let clientList = (await getAllClient()).data.payload.rows;
    this.header.searchs.forEach(async item => {
      if (item.key === "to_station") item.options = list.ToStation;
      // if (item.key === "from_station") item.options = list.FromStation;
      if (item.key === "clearance_agent") item.options = list.ClearanceAgent;
      if (item.key === "client_id") item.options = clientList;
    });
    this.modals.update.fields.forEach(async item => {
      if (item.key === "to_station") item.options = list.ToStation;
      if (item.key === "from_station") item.options = list.ToStation;
      if (item.key === "from_airport") item.options = airportList;
      if (item.key === "to_airport") item.options = airportList;
      if (item.key === "clearance_agent") item.options = list.ClearanceAgent;
      // if (item.key === "client_id") item.options = clientList;
    });
  },
  methods: {},
  data() {
    let that = this;
    return {
      list: [],
      selData: {
        toStation: [],
        fromStation: [],
        clearance_agent: []
      },
      order: [],
      title: "",
      methods: {
        list: p => {
          p["method"] = p["method"] ? p["method"] : "get";
          return operEndTripBill(p);
        },
        operEndTripBill,
        getSelectType,
        getKeysType,
        getAllClient,
        addEndTripBill,
        moveEndTripBill,
        exportEndTripBill,
        getEndTripBill,
        addRemark,
        createBill,
        exportPreAlert,
        order,
        remoteMethod(query) {
          console.log(query);
        }
      },
      modals: {
        order: {
          methods: {
            cancel: () => {
              this.list = [];
            }
          },
          contentSlot: "showDetails",
          config: {
            modalBind: {
              width: 850,
              draggable: true
            },
            modalContentBind: {
              style: {
                height: "650px"
              }
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("all") + this.$t("copy"),
                key: "copy",
                fnName: "copy",
                bind: {
                  type: "primary",
                  style: {
                    margin: "0 10px"
                  }
                }
              }
            ],
            methods: {
              copy() {
                let data = this.params.list.join("\r\n");
                copyClick.copyToClipboard(data, this);
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        showWarehouse: {
          contentSlot: "SHOWWAREHOUSE",
          config: {
            title: "not_arrival_warehouse",
            width: 600
          },
          footer: {
            ok: {
              name: () => this.$t("copy")
            },
            cancel: {}
          },
          methods: {
            ok: () => {
              let data = this.list.join("\r\n");
              copyClick.copyToClipboard(data, this);
            }
          }
        },
        moveModal: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("moveEndTripBill", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              package_number: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur"
                }
              ],
              awb: [
                {
                  required: true,
                  type: "string",
                  message: "AWB cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ package_number: 24 }, { awb: 24 }],
          fields: [
            {
              key: "package_number",
              name: () => this.$t("bagNum"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagNum");
              }
            },
            {
              key: "awb",
              name: () => this.$t("orderNum"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4
              },
              placeholder() {
                return this.$t("enter") + this.$t("orderNum");
              }
            }
          ]
        },
        openCost: {
          contentSlot: "cost",
          config: {
            modalBind: {
              styles: {
                top: "30px"
              },
              width: 90,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        },
        update: {
          methods: {
            ok({ row, close }) {
              let type = "list";
              let formData = row;
              if (!row.id) {
                type = row.id ? "list" : "addEndTripBill";
                formData = new FormData();
                for (let i in row) {
                  formData.append(i, row[i]);
                }
              }
              this.$page.handleRequestMethods(type, formData, true).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            listFn: "list",
            modalBind: {
              // styles: {
              //   top: "30px",
              // },
              width: 60
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  type: "number",
                  message: "clearance agent cannot be empty",
                  trigger: "change"
                }
              ],
              clearance_agent: [
                {
                  required: true,
                  message: "clearance agent cannot be empty",
                  trigger: "blur"
                }
              ],
              // clearance_date: [
              //   {
              //     required: true,
              //     type: "date",
              //     message: "clearance agent cannot be empty",
              //     trigger: "change",
              //   },
              // ],
              from_station: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change"
                }
              ],
              to_station: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change"
                }
              ],
              from_airport: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change"
                }
              ],
              to_airport: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change"
                }
              ],
              // dept_date: [
              //   {
              //     required: true,
              //     type: "date",
              //     message: "to Station cannot be empty",
              //     trigger: "change",
              //   },
              // ],
              // expected_date: [
              //   {
              //     required: true,
              //     type: "date",
              //     message: "to Station cannot be empty",
              //     trigger: "change",
              //   },
              // ],
              // depart_date: [
              //   {
              //     required: true,
              //     type: "date",
              //     message: "to Station cannot be empty",
              //     trigger: "change",
              //   },
              // ],
              // arrival_date: [
              //   {
              //     required: true,
              //     type: "date",
              //     message: "to Station cannot be empty",
              //     trigger: "change",
              //   },
              // ],
              flight: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur"
                }
              ],
              mawb: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur"
                }
              ],
              weight: [
                {
                  required: true,
                  type: "string",
                  message: "weight cannot be empty",
                  trigger: "blur"
                }
              ],
              files: [
                {
                  required: true,
                  type: "string",
                  message: "files cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { client_id: 12, mawb: 12 },
            { from_station: 12, to_station: 12 },
            {
              flight: 12,
              weight: 12
            },
            { charge_weight: 12, volume_weight: 12 },
            { from_airport: 12, to_airport: 12 },
            { dept_date: 12, expected_date: 12 },
            { shipping_agent_date: 12, depart_date: 12 },
            { arrival_date: 12, clearance_start_date: 12 },
            { clearance_date: 12, clearance_agent: 12 },
            { file: 24 },
            { fastener: 12, remarks: 12 }
          ],
          fields: [
            {
              name: () => this.$tz("计费重量"),
              key: "charge_weight",
              component: "Input",
              placeholder: () => this.$tz("计费重量")
            },
            {
              name: () => this.$tz("体积重量"),
              key: "volume_weight",
              component: "Input",
              placeholder: () => this.$tz("体积重量")
            },
            {
              key: "fastener",
              name: () => this.$t("fastening"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("fastening");
              }
            },
            {
              key: "shipping_agent_date",
              name: () => this.$t("Air Agency Time"),
              component: "DatePicker",
              bind: {
                type: "datetime"
              },
              data: ["arrival_HK_date", "depart_date"],
              placeholder() {
                return this.$t("enter") + this.$t("Air Agency Time");
              }
            },
            {
              key: "clearance_start_date",
              name: () => this.$t("Clearance Start Time"),
              component: "DatePicker",
              bind: {
                type: "datetime"
              },
              data: ["arrival_date", "clearance_date"],
              placeholder() {
                return this.$t("enter") + this.$t("Clearance Start Time");
              }
            },
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("clientName");
              },
              options: [],
              config: { label: "account", value: "id" },
              bind: {
                filterable: 'filterable',
                'remote-method': keywords => {
                  if (keywords.length >= 3) {

                    // 向远端请求数据
                    searchClient({keywords}).then(res => {
                      this.$refs['table'].getModal('update').fields.map(v => {
                        if (v.key === 'client_id') {
                          v.options = res.data.payload.rows
                        }
                      })
                    })
                  }
                }
              },
              methods: {

              }
            },
            {
              key: "mawb",
              name: () => this.$t("mawb"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("mawb");
              }
            },
            // {
            //   key: "from_station",
            //   name: () => this.$t("allow_depart"),
            //   component: "Input",
            //   placeholder() {
            //     return this.$t("enter") + this.$t("allow_depart");
            //   },
            // },
            {
              key: "from_station",
              name: () => this.$t("allow_depart"),
              component: "Select",
              config: {
                label: "name",
                value: "key"
              },
              placeholder() {
                return this.$t("select") + this.$t("allow_depart");
              },
              options: []
            },
            {
              key: "to_station",
              name: () => this.$t("allow_arrive"),
              component: "Select",
              config: {
                label: "name",
                value: "key"
              },
              placeholder() {
                return this.$t("select") + this.$t("allow_arrive");
              },
              options: []
            },
            {
              key: "from_airport",
              name: () => this.$t("departureAirport"),
              component: "Select",
              config: {
                label: "code",
                value: "code"
              },
              placeholder() {
                return this.$t("select") + this.$t("departureAirport");
              },
              options: []
            },
            {
              key: "to_airport",
              name: () => this.$t("destinationAirport"),
              component: "Select",
              config: {
                label: "code",
                value: "code"
              },
              placeholder() {
                return this.$t("select") + this.$t("destinationAirport");
              },
              options: []
            },
            {
              key: "dept_date",
              name: () => this.$t("dept_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              },
              placeholder() {
                return this.$t("select") + this.$t("dept_date");
              }
            },
            {
              key: "expected_date",
              name: () => this.$t("expected_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              },
              placeholder() {
                return this.$t("select") + this.$t("expected_date");
              }
            },
            {
              key: "depart_date",
              name: () => this.$t("amount_actual") + this.$t("depart_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("amount_actual") +
                  this.$t("depart_date")
                );
              },
              show: ({ row }) => {
                return !!row.id;
              }
            },
            {
              key: "arrival_date",
              name: () => this.$t("amount_actual") + this.$t("toHKtime"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("amount_actual") +
                  this.$t("toHKtime")
                );
              },
              show: ({ row }) => {
                return !!row.id;
              }
            },
            {
              key: "clearance_date",
              name: () => this.$t("clearance_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              },
              placeholder() {
                return this.$t("enter") + this.$t("clearance_date");
              },
              show: ({ row }) => {
                return !!row.id;
              }
            },
            {
              key: "flight",
              name: () => this.$t("flight"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("flight");
              }
            },
            {
              key: "weight",
              name: () => this.$t("Weight"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Weight");
              }
            },
            // {
            //   key: "package_number_total",
            //   name: () => this.$t("invoicePCS"),
            //   component: "InputNumber",
            //   bind: {
            //     style: "width: 100%",
            //   },
            //   default: 0,
            //   placeholder() {
            //     return this.$t("enter") + this.$t("invoicePCS");
            //   },
            // },
            {
              key: "clearance_agent",
              name: () => this.$t("clearagent"),
              component: "Select",
              options: [],
              config: {
                label: "name",
                value: "key"
              },
              placeholder() {
                return this.$t("select") + this.$t("clearagent");
              }
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            },
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "file",
              component: "Upload",
              show: ({ row }) => {
                return !row.id;
              },
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls",
                tempUrl:
                  this.$globalUrl + "/static/templates/uploadPackage.xlsx"
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                }
              }
            }
          ]
        },
        remark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            rules: {
              remark_instruction: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remark_instruction: 24 }],
          fields: [
            {
              key: "remark_instruction",
              name: () => this.$t("instruction"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("instruction");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "endStatus",
            placeholder() {
              return this.$t("select") + this.$t("finish") + this.$t("exlType");
            },
            component: "Select",
            options: [
              { label: this.$t("Not") + this.$t("finish"), value: 0 },
              { label: this.$t("finish"), value: 1 }
            ]
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["TRIP_STATUS_TYPE"])).data
                  .payload["TRIP_STATUS_TYPE"];
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          // {
          //   key: "dateType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["AIR_EXTRACT_SELECT_TYPE"]))
          //         .data.payload["AIR_EXTRACT_SELECT_TYPE"];
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          // {
          //   key: "startTime",
          //   component: "DatePicker",
          //   placeholder() {
          //     return (
          //       this.$t("select") +
          //       this.$t("start") +
          //       this.$t("date") +
          //       this.$t("time")
          //     );
          //   },
          //   bind: {
          //     type: "datetime",
          //     options: {
          //       disabledDate(time) {
          //         return time.getTime() > Date.now();
          //       },
          //     },
          //     style: {
          //       width: "175px",
          //     },
          //   },
          //   methods: {
          //     "on-change"({ searchForm }) {
          //       searchForm.startTime = searchForm.startTime
          //         ? this.$page.format.timeFormat(searchForm.startTime)
          //         : "";
          //     },
          //     // format({ searchForm, value, newFormData }) {
          //     //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
          //     // }
          //   },
          // },
          // {
          //   key: "endTime",
          //   component: "DatePicker",
          //   placeholder() {
          //     return this.$t("select") + this.$t("end") + this.$t("date");
          //   },
          //   bind: {
          //     type: "datetime",
          //     options: {
          //       disabledDate(time) {
          //         return time.getTime() > Date.now();
          //       },
          //     },
          //     style: {
          //       width: "175px",
          //     },
          //   },
          //   methods: {
          //     // format({ searchForm, value, newFormData }) {
          //     //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
          //     // }
          //     "on-change"({ searchForm }) {
          //       let time = this.$page.format.timeFormat(searchForm.endTime);
          //       if (time.slice(-8) === "00:00:00") {
          //         time = time.split(" ")[0] + " " + "23:59:59";
          //         searchForm.endTime = time;
          //       }
          //     },
          //   },
          // },
          // {
          //   key: "from_station",
          //   placeholder() {
          //     return this.$t("select") + this.$t("allow_depart");
          //   },
          //   component: "Select",
          //   config: {
          //     label: "name",
          //     value: "key",
          //   },
          //   options: [],
          // },
          {
            key: "to_station",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            config: {
              label: "name",
              value: "key"
            },
            options: []
          },
          {
            key: "clearance_agent",
            placeholder() {
              return this.$t("select") + this.$t("clearagent");
            },
            component: "Select",
            config: {
              label: "name",
              value: "key"
            },
            options: []
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            },
            config: { label: "account", value: "id" }
            // methods: {
            //   async list({ field, row }) {
            //     let res = (await getAllClient()).data.payload.rows;
            //     field.options = res;
            //     this.$forceUpdate();
            //   }
            // }
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("EXTRACT_END_KEYWORDS")).data
                  .payload["EXTRACT_END_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download"
              },
              disabled(row) {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("add"),
              fnName: "addFun",
              type: "add",
              bind: {
                type: "primary"
              },
              id: 1084
            },
            {
              name: () => this.$t("createBill"),
              fnName: "createBill",
              type: "createBill",
              bind: {
                type: "primary"
              },
              id: 1300
            }
          ],
          methods: {
            createBill({ searchForm }) {
              this.handleRequestMethods(
                "createBill",
                { ...searchForm, ids: this.selectAll.map(t => t.id) },
                false,
                true
              ).then(res => {
                this.$Message.success({
                  background: true,
                  content: res.message || res.msg || "success",
                  duration: 5
                });
              });
            },
            addFun({ searchForm }) {
              this.getModal("update").open({ method: "post" }, function() {
                this.setTitle(this.$t("add"));
              });
            },
            exportFun({ row, field, searchForm }) {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "left",
          minWidth: 120,
          fixed: "left",
          header: {
            copy: true //头部复制
          }
        },
        {
          name: () => this.$t("flight"),
          key: "flight",
          minWidth: 100
        },
        {
          name: () => this.$t("number_of_bags"),
          key: "package_number_total",
          minWidth: 115
        },
        {
          name: () => this.$t("cod_number"),
          key: "airway_number_total",
          minWidth: 115
        },
        {
          name: () => this.$t("b2bClient"),
          key: "client_name",
          minWidth: 80
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_station",
          minWidth: 80
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_station",
          minWidth: 80
        },
        {
          name: () => this.$t("not_arrival_warehouse"),
          key: "not_warehouse_total",
          minWidth: 80,
          render: (h, params) => {
            if (params.row.not_warehouse_total > 0) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.list = [];
                        this.$refs["table"].getModal("showWarehouse").open();
                        this.$refs["table"]
                          .handleRequestMethods("getEndTripBill", {
                            mawb: params.row.mawb
                          })
                          .then(res => {
                            this.list = res.payload;
                          });
                      }
                    }
                  },
                  params.row.not_warehouse_total
                )
              ]);
            } else {
              return h("div", [
                h(
                  "span",

                  0
                )
              ]);
            }
          }
        },
        {
          name: () => this.$t("departureAirport"),
          key: "from_airport",
          minWidth: 80
        },
        {
          name: () => this.$t("destinationAirport"),
          key: "to_airport",
          minWidth: 80
        },
        {
          name: () => this.$t("clearagent"),
          key: "clearance_agent",
          minWidth: 120
        },
        {
          name: () => this.$t("depart_date"),
          key: "depart_date",
          minWidth: 115
        },
        {
          name: () => this.$t("toHKtime"),
          key: "arrival_date",
          minWidth: 130
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          minWidth: 115
        },
        {
          name: () => this.$t("overseasInboundTime"),
          key: "arrival_warehouse",
          minWidth: 115
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          minWidth: 115
        },
        {
          name: () => this.$tz('计费重'),
          key: 'charge_weight',
          minWidth: 110,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          width: 130
        },
        {
          name: () => this.$t("instruction"),
          key: "remark_instruction",
          width: 130,
          component: "a",
          methods: {
            click({ row }) {
              let data = {
                mawb: row.mawb,
                remark_instruction: row.remark_instruction
              };
              this.$page.getModal("remark").open(data, function() {
                this.setTitle(
                  (row.remark_instruction
                    ? this.$t("update")
                    : this.$t("add")) + this.$t("instruction")
                );
              });
            },
            render({ row }) {
              return row.remark_instruction
                ? row.remark_instruction
                : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("assistDepartment"),
          key: "department",
          minWidth: 115
        },
        {
          name: () => this.$t("createUser"),
          key: "operator_name",
          minWidth: 115
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 115
        },
        // {
        //   name: () => this.$t("createUser"),
        //   key: "creator_name",
        //   minWidth: 130,
        // },
        {
          type: "btns",
          width: 300,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$tz("订单"),
              type: "order",
              fnName: "order",
              bind: {
                type: "primary"
              },
              id: 1999
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 1083
            },
            {
              name: () => this.$t("MoveIn"),
              type: "IN",
              fnName: "moveFun",
              bind: {
                type: "warning"
              },
              id: 1082
            },
            {
              name: () => this.$t("MoveOut"),
              type: "OUT",
              fnName: "moveFun",
              bind: {
                type: "error"
              },
              id: 1082
            },
            {
              name: () => this.$t("agentT") + this.$t("finalCost"),
              type: "openCost",
              fnName: "openCost",
              data: {
                type: 5
              },
              bind: {
                type: "warning"
              },
              id: 1288
            },
            {
              name: () => this.$t("export") + "manifest",
              type: "exportEndTripBill",
              fnName: "exportFun",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("export") + "pre-Alert",
              type: "exportPreAlert",
              fnName: "exportFun",
              bind: {
                type: "primary"
              }
            }
            // {
            //   name: () => this.$t("delete"),
            //   type: "delete",
            //   fnName: "deleteFun",
            //   bind: {
            //     type: "error",
            //   },
            // },
          ],

          methods: {
            order({ row }) {
              this.handleRequestMethods(
                "order",
                { mawb: row.mawb },
                false,
                true
              ).then(res => {
                this.getModal("order").open({ list: res.payload }, function() {
                  this.setTitle(this.$tz("订单"));
                });
              });
            },
            openCost({ row, field }) {
              row.resType = field.data.type;
              this.getModal("openCost").open(row, function() {
                this.setTitle(this.$t("agentT") + this.$t("finalCost"));
              });
            },
            async updateFun({ fields, row }) {
              // row["method"] = "put";
              let data = {};
              this.getModal(
                "update"
              ).$page.$parent.modals.update.fields.forEach(item => {
                data[item.key] = row[item.key];
              });
              data["id"] = row.id;
              data["method"] = "put";
              this.getModal("update").open(data, function() {
                this.setTitle(this.$t("update"));
              });
            },
            moveFun({ field, row }) {
              this.getModal("moveModal").open(
                { type: field.type, mawb: row.mawb },
                function() {
                  this.setTitle(field.name());
                }
              );
            },
            exportFun({ row, field }) {
              this.handleRequestMethods(field.type, row.id, true, true).then(
                res => {
                  window.open(this.$globalUrl + res.payload);
                }
              );
            }
            // deleteFun({ row }) {
            //   this.$Modal.confirm({
            //     title:
            //       this.$t("whether") +
            //       this.$t("confirm") +
            //       this.$t("delete") +
            //       this.$t("mawb") +
            //       ":" +
            //       row.mawb +
            //       "?",
            //     onOk: () => {
            //       this.handleRequestMethods(
            //         "list",
            //         { id: row.id, method: "delete" },
            //         true
            //       ).then((res) => {
            //         // this.$Message.success(res.data.msg);
            //         this.getList();
            //       });
            //     },
            //   });
            // },
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
.content {
  height: 100%;
}
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
